module.exports = __webpack_public_path__ + "fonts/googleAuth_70x70.61922dbce81f2eda6b4126777b197577.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/googleAuth_70x70.png
// module id = 738
// module chunks = 9